<template>
    <router-view />
</template>

<style src="@/assets/bootstrap.min.css" />